/* eslint-disable no-param-reassign */
import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { ScopeSelector } from '@bingads-webui-react/scope-selector';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { findParentNodeByLevel } from './utils';

export const Loader = (props) => {
  const { siteMap, updateAvailability, level } = props;

  const selectedParent = findParentNodeByLevel(siteMap, level); // level index 0 for PageMenu, 1 for SubPageMenu and 2 for subTab
  const available = !_.isEmpty(selectedParent);

  useEffect(() => {
    updateAvailability(available);
  });

  if (available) {
    const levelItems = selectedParent.children.map(child => ({
      name: props.i18n.getString(child.name),
      href: `/campaign/vnext/${child.route}`,
      ariaDescription: child.ariaDescription ? props.i18n.getString(child.ariaDescription) : '',
    }));

    const currentPath = props.location.pathname;
    const currentIndex = levelItems.findIndex(item => item.href === currentPath);

    const onItemChange = ({ index }) => {
      props.scope.save(levelItems[index].href);
    };

    const pillControlParams = { levelIndex: currentIndex, onItemChange, levelItems };
    return <ScopeSelector pillControlParams={pillControlParams} selectedParent={selectedParent.id} />;
  }

  return null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  level: PropTypes.number,
  updateAvailability: PropTypes.func,
  scope: PropTypes.shape({
    save: PropTypes.func.isRequired,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
  level: 2,
  scope: {
    save: _.noop,
  },
  location: {
    pathname: '/campaign/vnext/labelscampaign',
  },
};

export const DefaultSubTabLoader = React.memo(withI18nConsumer(Loader));
